<!-- SECTION HEADER -->
<header></header>

<div class="overflow-y-scroll">
	<!-- SECTION HERO + SUBNAV -->
	<hero></hero>
	<subnav [isTitleMode]="true" title="{{ 'wap1_p_help_title' | translate }}"></subnav>

	<div class="container-fluid px-4">
		<div class="row my-5">
			<!-- d-none: hidden on smaller screens, d-lg-block: visible on lg screens and above -->
			<div class="col-2 d-none d-lg-block d-flex align-items-center"></div>
			<div class="col-12 col-lg-8 d-flex align-items-center">
				<div class="col">
					<div class="markdown-container p-3" [innerHTML]="'wap1_p_help_help' | translate | safeMark"></div>
				</div>
			</div>
			<div class="col-2 d-none d-lg-block d-flex align-items-center"></div>
		</div>

		<div class="row my-5">
			<!-- d-none: hidden on smaller screens, d-lg-block: visible on lg screens and above -->
			<div class="col-2 d-none d-lg-block d-flex align-items-center"></div>
			<div class="col-12 col-lg-8 d-flex align-items-center">
				<div class="col">
					<div id="faq" class="markdown-container p-3" [innerHTML]="'wap1_p_help_faq' | translate | safeMark"></div>
				</div>
			</div>
			<div class="col-2 d-none d-lg-block d-flex align-items-center"></div>
		</div>

		<div class="row my-5">
			<!-- d-none: hidden on smaller screens, d-lg-block: visible on lg screens and above -->
			<div class="col-2 d-none d-lg-block d-flex align-items-center"></div>
			<div class="col-12 col-lg-8 d-flex align-items-center">
				<div class="col">
					<div id="affiliateLinks" class="markdown-container p-3" [innerHTML]="'wap1_p_help_affiliate' | translate | safeMark">
					</div>
				</div>
			</div>
			<div class="col-2 d-none d-lg-block d-flex align-items-center"></div>
		</div>

		<div class="row my-5">
			<!-- d-none: hidden on smaller screens, d-lg-block: visible on lg screens and above -->
			<div class="col-2 d-none d-lg-block d-flex align-items-center"></div>
			<div class="col-12 col-lg-8 d-flex align-items-center">
				<div class="col">
					<div class="markdown-container p-3" [innerHTML]="'wap1_c_footer_hereForYou' | translate | safeMark">
					</div>
				</div>
			</div>
			<div class="col-2 d-none d-lg-block d-flex align-items-center"></div>
		</div>
	</div>

	<hr>
	<footer></footer>
</div>